export default "__VITE_ASSET__BnX0pA6K__"